import { List } from 'immutable';
import { fundDocConstants } from '../constants';

const INITIAL_STATE = {
  createError: null,
  createLoading: false,
  editError: null,
  editLoading: false,
  listError: null,
  listLoading: false
};

export function fundDocs(state = INITIAL_STATE, action) {
  switch (action.type) {
    case fundDocConstants.FUND_DOC_LIST_LOADING:
      return {
        ...state,
        listLoading: true
      };
    case fundDocConstants.FUND_DOC_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case fundDocConstants.FUND_DOC_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: [],
        listError: action.error
      };

    case fundDocConstants.FUND_DOC_LIST_CLEAR:
      return {
        ...state,
        items: null
      };

    case fundDocConstants.FUND_DOC_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case fundDocConstants.FUND_DOC_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case fundDocConstants.FUND_DOC_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case fundDocConstants.FUND_DOC_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case fundDocConstants.FUND_DOC_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const fundDocIndex = state.items.findIndex(val => val.id == action.response.id);

      if (fundDocIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(fundDocIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case fundDocConstants.FUND_DOC_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case fundDocConstants.FUND_DOC_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case fundDocConstants.FUND_DOC_DELETE_SUCCESS: {
      const { fundDocId } = action;

      if (!state.items) {
        return state;
      }

      const fundDocIndex = state.items.findIndex(val => val.id == fundDocId);

      if (fundDocIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(fundDocIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case fundDocConstants.FUND_DOC_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case fundDocConstants.FUND_DOC_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
